import React, { useEffect, Fragment, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { LoadingComponent } from 'recupero-comunes';
import { FaRegFileAlt } from "react-icons/fa";
import { serviceGetCfgForm, serviceGetDetalles, servicePagosEmitidos } from '../../api/api-consulta-hitos';
import { formato_monto } from '../../common/Formatos';
import DetallePagoEmitido from './detalle-gago-emitido';


const ConsultaPagosEmitidos = ({ showModal, setShowModal, idCaso, idOrgCaso }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [cfg_form, setCfg_form] = useState(null);
    const [tiposPagos, setTiposPagos] = useState([]);
    const [stateTipoPago, setStateTipoPago] = useState("");
    const [stateTodos, setStateTodos] = useState(true);

    const [showDetalle, setShowDetalle] = useState(false);
    const [medioPago, setMedioPago] = useState(null);

    const columnas = [
        {
            dataField: 'TipoPago',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-tipopago'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'Implicado',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-implicado'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'FechaPagoFormato',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-fecha'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'Cobertura',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-cober'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'DestinatarioPago',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-dest'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'NumBoletaFact',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-boleta'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'FechaBoletaFactFormato',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-fechadocto'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'MonedaPago',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-moneda'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'MontoNeto',
            text: cfg_form && cfg_form['modalconsultapagosemitidos-grilla-neto'],
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            formatter: (cell, row) => <span>{formato_monto(row.MontoNeto)}</span>,
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaRegFileAlt
                    size={20}
                    title={"Ver Detalle de Pago Emitido"}
                    style={{ color: 'gray', cursor: 'pointer' }}
                    onClick={() => handleDetalle(row)}
                />
            },
        }
    ];

    useEffect(() => {
        if (showModal) initialData();
    }, [showModal])

    const initialData = async () => {
        await getCfgForm();
        await getTiposPagos();
        await getPagosEmitidos();
    }

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgCaso, idform: 61 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getTiposPagos = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 267 })).toString('base64');

        const response = await serviceGetDetalles(query);
        setTiposPagos(response);
    }

    const handleTipoPago = (value) => {
        setStateTipoPago(value);
        if (value !== "") { setStateTodos(false); setData([]) }
        else { setStateTodos(true); setData([]) }
    }

    const handleTodos = (value) => {
        setStateTodos(value);
        if (value) { setStateTipoPago(""); setData([]) }
    }

    const handleClose = () => {
        setShowModal(false);
        setStateTipoPago("");
        setStateTodos(true);
        setData([]);
    }

    const getPagosEmitidos = async () => {
        setLoading(true);
        if (stateTipoPago === "" && !stateTodos) setStateTodos(true);

        const query = Buffer.from(JSON.stringify({
            idCaso: idCaso,
            tipoPago: stateTipoPago !== "" ? stateTipoPago : null,
            checkTodos: stateTipoPago !== "" ? false : true,
        })).toString('base64');

        const response = await servicePagosEmitidos(query);
        setData(response);
        setLoading(false);
    }

    const handleDetalle = (data) => {
        setShowDetalle(true); setMedioPago(data);
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={handleClose} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        {cfg_form && cfg_form['modalconsultapagosemitidos-title']}
                    </Card.Header>

                    <Card.Body>
                        <Row>
                            <Col md='3'>
                                <Form.Label>
                                    {cfg_form && cfg_form['modalconsultapagosemitidos-cmb-tipopago']}
                                </Form.Label>
                                <Form.Select
                                    name='stateTipoPago'
                                    onChange={(e) => handleTipoPago(e.target.value)}
                                    value={stateTipoPago}>

                                    <option value={""}>Seleccione</option>
                                    {tiposPagos && tiposPagos
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                            </Col>
                            <Col md='4'>
                                <Form.Check
                                    style={{ marginTop: '35px' }}
                                    name="stateTodos"
                                    label={cfg_form && cfg_form['modalconsultapagosemitidos-chk-todos']}
                                    checked={stateTodos}
                                    onChange={(e) => handleTodos(e.target.checked)}
                                />
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                        <Row>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                    {cfg_form && cfg_form['modalconsultapagosemitidos-btn-volver']}
                                </Button>
                                <Button style={{ width: '110px', color: 'white' }} variant='info' onClick={getPagosEmitidos}>
                                    {cfg_form && cfg_form['modalconsultapagosemitidos-btn-buscar']}
                                </Button>
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                        <ToolkitProvider
                            search
                            bootstrap4
                            keyField="id"
                            data={data ? data : []}
                            columns={columnas}
                            defaultSorted={[{ dataField: 'id', order: 'asc' }]}>
                            {props =>
                                <>
                                    <Row>
                                        <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                            <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                            <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                        </Col>
                                    </Row>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        headerWrapperClasses="table-secondary"
                                        noDataIndication={
                                            <div className="text-center">No hay registros encontrados.</div>
                                        }
                                    />
                                </>
                            }
                        </ToolkitProvider>
                    </Card.Body>
                </Card>
            </Modal>

            <DetallePagoEmitido
                cfg_form={cfg_form}
                showDetalle={showDetalle}
                setShowDetalle={setShowDetalle}
                medioPago={medioPago}
            />

            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaPagosEmitidos;